export default {
      id: "shared-usage",
      viewBox: "0 0 17 14",
      url: __webpack_public_path__ + "icons.svg#shared",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared.svg
// module id = 288
// module chunks = 0